module.exports = __webpack_public_path__ + "img/searchHead.b7e7030c.svg";